/* !
 * jQuery index v1.0.0
 * Copyright 2019, Connecty Inc.
 */
(function($, DIC){
	const a = 'is-active';
	const v = 'is-visible';
	const f = 'is-fixed';
	const slideSpeed = '400';
	const lang = location.pathname.split('/')[1];
	let i, j, k, l;

	// 製品テンプレートjson出力------------------------------------------------------------------------------------
	const pageCategory1 = location.pathname.split('/')[3];
	const pageCategory2 = location.pathname.split('/')[4];
	const attributePage = $('.products-attribute').length;
	const lineupArea = $('.inc_products_lineup');
	const lineupBlock = $('.js-products-set-lineup');
	let lineupHtml;
	let lineupDate = [];
	const appArea = $('.inc_products_application');
	const appBlock = $('.js-products-set-app');
	let appHtml;
	let appDate = [];
	const catalogArea = $('.inc_products_catalog');
	const catalogBlock = $('.js-products-set-catalog');
	const catalogHead = $('.inc_products_catalog #catalog');
	let cmsData;
	let catalogDate = [];
	let anchorLinkCount = 0;

	// JSON取得 ---------------------------------------------------
	// 用途json取得用
	const getJSONapp = () => {
		if(!(pageCategory2 === '' || pageCategory2.match('.html'))) {
			// 下層カテゴリ用
			return $.getJSON(`/${lang}/ajax/products/${pageCategory1}/${pageCategory2}/app.json`);
		} else {
			// カテゴリ用
			return $.getJSON(`/${lang}/ajax/products/${pageCategory1}/app.json`);
		}
	};
	// 製品ラインナップjson取得用
	const getJSONlineup = () => {
		if(!(pageCategory2 === '' || pageCategory2.match('.html'))) {
			// 下層カテゴリ用
			return $.getJSON(`/${lang}/ajax/products/${pageCategory1}/${pageCategory2}/lineup.json`);
		} else {
			return $.getJSON(`/${lang}/ajax/products/${pageCategory1}/lineup.json`);
		}
	};
	// 製品カタログjson取得用
	const getJSONcatalog = () => {
		if(!attributePage) {
			if(!(pageCategory2 === '' || pageCategory2.match('.html'))) {
				// 下層カテゴリ用
				return $.getJSON(`/${lang}/ajax/products/${pageCategory1}/${pageCategory2}/catalog.json`);
			} else {
				// カテゴリ用
				return $.getJSON(`/${lang}/ajax/products/${pageCategory1}/catalog.json`);
			}
		} else {
			// 属性ページ用
			return $.getJSON(`/${lang}/ajax/products/${pageCategory1.replace('.html', '')}/catalog.json`);
		}
	};
	// 用途・製品ラインナップ共通html出力部分 -------------------------
	const setHtml = (_data, _html, _block) => {
		// テーブル用
		const tableHtml = ($data) => {
			_html += '<div class="mod-tblWrap mod-spacer_m40"><table class="mod-tbl05">';
			let thCount = 0;
			for(l = 0; l < $data.length; l++) {
				if(l === 0) {
					if(!$data[0].bg) {
						_html += '<thead><tr>';
					} else {
						_html += '<thead><tr style="background:#'+$data[0].bg+'">';
					}
					for(j = 0; j < 15; j++) {
						if($data[0].link[j]) {
							if($data[0].name[j]) {
								if(!$data[0].bg) {
									_html += '<th>'+
									'<a class="mod-link02" target="_blank" href="'+$data[0].link[j]+'">'+$data[0].name[j].replace(/\r?\n/g, '<br>')+'</a></th>';
								} else {
									_html += '<th style="background:#'+$data[0].bg+'">'+
									'<a class="mod-link02" target="_blank" href="'+$data[0].link[j]+'">'+$data[0].name[j].replace(/\r?\n/g, '<br>')+'</a></th>';
								}
								thCount++;
							}
						} else {
							if($data[0].name[j]) {
								if(!$data[0].bg) {
									_html += '<th>'+$data[0].name[j].replace(/\r?\n/g, '<br>')+'</th>';
								} else {
									_html += '<th style="background:#'+$data[0].bg+'">'+$data[0].name[j].replace(/\r?\n/g, '<br>')+'</th>';
								}
								thCount++;
							}
						}
					}
					_html += '</tr></thead><tbody>';
				}
				if(!(l === 0)) {
					if(!$data[l].bg) {
						_html += '<tr>';
					} else {
						_html += '<tr style="background:#'+$data[l].bg+'">';
					}
					for(let m = 0; m < thCount; m++) {
						if($data[l].link[m]) {
							_html += '<td>'+
							'<a class="mod-link02" target="_blank" href="'+$data[l].link[m]+'">'+$data[l].name[m].replace(/\r?\n/g, '<br>')+'</a></td>';
						} else {
							_html += '<td>'+$data[l].name[m].replace(/\r?\n/g, '<br>')+'</td>';
						}
					}
					_html += '</tr>';
				}
			}
			_html += '</tbody></table></div>';
		};
		// ulリスト用
		const listHtml = ($data) => {
			_html += '<ul class="ul-disc mod-spacer_m40">';
			for(l = 0; l < $data.length; l++) {
				for(j = 0; j < 15; j++) {
					if($data[l].link[j]) {
						if($data[l].name[j]) {
							if(!$data[l].bg) {
								_html += '<li><span>'+
							'<a class="mod-link02" target="_blank" href="'+$data[l].link[j]+'">'+$data[l].name[j].replace(/\r?\n/g, '<br>')+'</a></span></li>';
							} else {
								_html += '<li style="background:#'+$data[l].bg+'">'+
							'<a class="mod-link02" target="_blank" href="'+$data[l].link[j]+'">'+$data[l].name[j].replace(/\r?\n/g, '<br>')+'</a></span></li>';
							}
						}
					} else {
						if($data[l].name[j]) {
							if(!$data[l].bg) {
								_html += '<li><span>'+$data[l].name[j].replace(/\r?\n/g, '<br>')+'</span></li>';
							} else {
								_html += '<li style="background:#'+$data[l].bg+'" class="p10">'+'<span>'+$data[l].name[j].replace(/\r?\n/g, '<br>')+'</span></li>';
							}
						}
					}
				}
			}
			_html += '</ul>';
		};
		for(k = 0; k < _data.length; k++) {
			if(!_data[k].link) {
				if(!_data[k].name) {
					_html = '<section class="mod-spacer_m40">';
				} else {
					_html = '<section class="mod-spacer_m40">'+
					'<h3 class="mod-head03">'+_data[k].name.replace(/\r?\n/g, '<br>')+'</h3>';
				}
			} else {
				if(!_data[k].name) {
					_html = '<section class="mod-spacer_m40">';
				} else {
					_html = '<section class="mod-spacer_m40">'+
					'<h3 class="mod-head03"><a href="'+_data[k].link+'" class="mod-link02" target="_blank">'+_data[k].name.replace(/\r?\n/g, '<br>')+'</a></h3>';
				}
			}
			if(_data[k].remarks) {
				_html += '<p>'+_data[k].remarks.replace(/\r?\n/g, '<br>')+'</p>';
			}
			if(_data[k].type === 'T') {
				tableHtml(_data[k].item);
			} else if(_data[k].type === 'L') {
				listHtml(_data[k].item);
			}
			if(_data[k].underRemarks) {
				_html += '<p class="pt20">'+_data[k].underRemarks.replace(/\r?\n/g, '<br>')+'</p>';
			}
			_block.append(_html);
		}
	};
	// ブロックの中身がなければ削除
	const areaHiddenJudgment = ($wrap, $wrapIn, $btn) => {
		if(!($wrapIn.text().replace(/^\s+/, '').length)) {
			$btn.addClass('is-hidden');
			$wrap.addClass('is-hidden');
		} else {
			$btn.addClass('is-active');
			$wrap.addClass('is-active');
		}
	};
	// データ出力 ---------------------------------------------------
	// 用途描画用
	const setJSONapp = () => {
		getJSONapp().then((data) => {
			if(data.rt_bn_app_list.length) {
				// console.log('getJSONapp', data, data.rt_bn_app_list, data.rt_bn_app_list.length);
				cmsData = data.rt_bn_app_list;
				let dataLength = 0;
				let itemLength = 0;
				// データ成型
				for(i = 0; i < cmsData.length; i++) {
					if(cmsData[i].cf_pa_in_element_order === (0)) {
						appDate[dataLength] = {
							name : cmsData[i].cf_pa_label_name,
							link : cmsData[i].cf_pa_label_link,
							type : cmsData[i].cf_pa_output_class,
							remarks : cmsData[i].cf_pa_label_side_remarks,
							underRemarks : cmsData[i].cf_pa_element_under_remarks,
							item : []
						};
						dataLength ++;
						itemLength = 0;
					}
					if(appDate[dataLength-1]) {
						appDate[dataLength-1].item[itemLength] = {
							bg : cmsData[i].cf_pa_in_element_bg_color,
							name : [cmsData[i].cf_pa_item_1,
								cmsData[i].cf_pa_item_2,
								cmsData[i].cf_pa_item_3,
								cmsData[i].cf_pa_item_4,
								cmsData[i].cf_pa_item_5,
								cmsData[i].cf_pa_item_6,
								cmsData[i].cf_pa_item_7,
								cmsData[i].cf_pa_item_8,
								cmsData[i].cf_pa_item_9,
								cmsData[i].cf_pa_item_10,
								cmsData[i].cf_pa_item_11,
								cmsData[i].cf_pa_item_12,
								cmsData[i].cf_pa_item_13,
								cmsData[i].cf_pa_item_14,
								cmsData[i].cf_pa_item_15],
							link : [cmsData[i].cf_pa_link_1,
								cmsData[i].cf_pa_link_2,
								cmsData[i].cf_pa_link_3,
								cmsData[i].cf_pa_link_4,
								cmsData[i].cf_pa_link_5,
								cmsData[i].cf_pa_link_6,
								cmsData[i].cf_pa_link_7,
								cmsData[i].cf_pa_link_8,
								cmsData[i].cf_pa_link_9,
								cmsData[i].cf_pa_link_10,
								cmsData[i].cf_pa_link_11,
								cmsData[i].cf_pa_link_12,
								cmsData[i].cf_pa_link_13,
								cmsData[i].cf_pa_link_14,
								cmsData[i].cf_pa_link_15]
						};
						itemLength ++;
					}
				}
				// console.log(appDate, 'appDate');
				// データ出力
				setHtml(appDate, appHtml, appBlock);
				// 出力データにクリックイベント
				$(document).on('click', '.inc_products_application a[rel="scroll"]', function(event){
					var speed = 1200;
					if(/#/.test(event.currentTarget.href)) {
						scrollToObject(event.currentTarget.href, speed);
					}
					return false;
				});
				function scrollToObject(_self, _speed){
					var hash = '#' + _self.split('#')[1];
					var pos = hash === '#pagetop' ? 0 : $(hash).offset().top;

					if(hash !== '#pagetop') {
						if(DIC.va.window.width < DIC.va.device.sp) {
							pos -= 60;
						} else {
							pos -= 100;
						}
					}
					$('html,body').stop().animate({ scrollTop: pos }, _speed, 'easeOutExpo');
				}
				// urlに#がある場合、ajax描画後にスクロールイベント発火
				const hash = location.hash;
				if(hash) {
					var _hash = '#' + hash.split('#')[1];
					if($(_hash).length) {
						$('body,html').css('opacity', 0);
						$('body,html').stop().scrollTop(0);
						setTimeout(function(){
							$('html, body').css('display', 'block');
							_hash = '#' + hash.split('#')[1];
							var pos = $(_hash).offset().top;

							if(DIC.va.window.width <= DIC.va.device.desktop) {
								pos -= 60;
							} else {
								pos -= 100;
							}
							$('body, html').css('opacity', 1);
							$('html, body').stop().animate({ scrollTop: pos }, 1200, 'easeOutExpo');
						}, 300);
					}
				}
			} else {
				appArea.addClass('di_none');
			}
			const applicationPageAnchor = $('.js-application-anchor');
			const applicationWrap = $('.js-application-area');
			const applicationWrapIn = $('.js-application-area-content');
			areaHiddenJudgment(applicationWrap, applicationWrapIn, applicationPageAnchor);
		});
	};
	// 製品ラインナップ描画用
	const setJSONlineup = () => {
		getJSONlineup().then((data) => {
			// データが入っていれば描画
			if(data.rt_bn_lineup_list.length) {
				// console.log('getJSONlineup', data, data.rt_bn_lineup_list, data.rt_bn_lineup_list.length);
				cmsData = data.rt_bn_lineup_list;
				let dataLength = 0;
				let itemLength = 0;
				// データ成型
				for(i = 0; i < cmsData.length; i++) {
					if(cmsData[i].cf_pl_in_element_order === 0) {
						lineupDate[dataLength] = {
							name : cmsData[i].cf_pl_label_name,
							link : cmsData[i].cf_pl_label_link,
							type : cmsData[i].cf_pl_output_class,
							remarks : cmsData[i].cf_pl_label_side_remarks,
							underRemarks : cmsData[i].cf_pl_element_under_remarks,
							item : []
						};
						dataLength ++;
						itemLength = 0;
					}
					if(lineupDate[dataLength-1]) {
						lineupDate[dataLength-1].item[itemLength] = {
							bg : cmsData[i].cf_pl_in_element_bg_color,
							name : [cmsData[i].cf_pl_item_1,
								cmsData[i].cf_pl_item_2,
								cmsData[i].cf_pl_item_3,
								cmsData[i].cf_pl_item_4,
								cmsData[i].cf_pl_item_5,
								cmsData[i].cf_pl_item_6,
								cmsData[i].cf_pl_item_7,
								cmsData[i].cf_pl_item_8,
								cmsData[i].cf_pl_item_9,
								cmsData[i].cf_pl_item_10,
								cmsData[i].cf_pl_item_11,
								cmsData[i].cf_pl_item_12,
								cmsData[i].cf_pl_item_13,
								cmsData[i].cf_pl_item_14,
								cmsData[i].cf_pl_item_15],
							link : [cmsData[i].cf_pl_link_1,
								cmsData[i].cf_pl_link_2,
								cmsData[i].cf_pl_link_3,
								cmsData[i].cf_pl_link_4,
								cmsData[i].cf_pl_link_5,
								cmsData[i].cf_pl_link_6,
								cmsData[i].cf_pl_link_7,
								cmsData[i].cf_pl_link_8,
								cmsData[i].cf_pl_link_9,
								cmsData[i].cf_pl_link_10,
								cmsData[i].cf_pl_link_11,
								cmsData[i].cf_pl_link_12,
								cmsData[i].cf_pl_link_13,
								cmsData[i].cf_pl_link_14,
								cmsData[i].cf_pl_link_15]
						};
						itemLength ++;
					}
				}
				// console.log(lineupDate, 'lineupDate');
				// データ出力
				setHtml(lineupDate, lineupHtml, lineupBlock);
				// 出力データにクリックイベント
				$(document).on('click', '.inc_products_lineup a[rel="scroll"]', function(event){
					var speed = 1200;
					if(/#/.test(event.currentTarget.href)) {
						scrollToObject(event.currentTarget.href, speed);
					}
					return false;
				});
				function scrollToObject(_self, _speed){
					var hash = '#' + _self.split('#')[1];
					var pos = hash === '#pagetop' ? 0 : $(hash).offset().top;

					if(hash !== '#pagetop') {
						if(DIC.va.window.width < DIC.va.device.sp) {
							pos -= 60;
						} else {
							pos -= 100;
						}
					}
					$('html,body').stop().animate({ scrollTop: pos }, _speed, 'easeOutExpo');
				}
				// urlに#がある場合、ajax描画後にスクロールイベント発火
				const hash = location.hash;
				if(hash) {
					var _hash = '#' + hash.split('#')[1];
					if($(_hash).length) {
						$('body,html').css('opacity', 0);
						$('body,html').stop().scrollTop(0);
						setTimeout(function(){
							$('html, body').css('display', 'block');
							_hash = '#' + hash.split('#')[1];
							var pos = $(_hash).offset().top;

							if(DIC.va.window.width <= DIC.va.device.desktop) {
								pos -= 60;
							} else {
								pos -= 100;
							}
							$('body, html').css('opacity', 1);
							$('html, body').stop().animate({ scrollTop: pos }, 1200, 'easeOutExpo');
						}, 300);
					}
				}
			} else {
				lineupArea.addClass('di_none');
			}
			const lineupPageAnchor = $('.js-lineup-anchor');
			const lineupWrap = $('.js-lineup-area');
			const lineupWrapIn = $('.js-lineup-area-content');
			areaHiddenJudgment(lineupWrap, lineupWrapIn, lineupPageAnchor);
		});
	};
	// 製品カタログ描画用
	const setJSONcatalog = () => {
		getJSONcatalog().then((data) => {
			if(data.rt_bn_catalog_list.length) {
				// console.log('getJSONcatalog', data, data.rt_bn_catalog_list, data.rt_bn_catalog_list.length);
				cmsData = data.rt_bn_catalog_list;
				let categorHtml;
				// データ成型
				for(i = 0; i < cmsData.length; i++) {
					if(cmsData[i].cf_pca_in_element_order === (0)) {
						catalogDate[cmsData[i].cf_pca_element_number-1] = {
							name : cmsData[i].cf_pca_name,
							img : cmsData[i].cf_pca_image,
							item : []
						};
					}
					catalogDate[cmsData[i].cf_pca_element_number-1].item[cmsData[i].cf_pca_in_element_order] = {
						link : cmsData[i].cf_pca_label_link,
						name : cmsData[i].cf_pca_label_name,
						class : cmsData[i].cf_pca_label_add_class
					};
				}
				// console.log(catalogDate, 'catalogDate');
				// データ出力
				for(k = 0; k < catalogDate.length; k++) {
					categorHtml = '<div class="mod-box01"><ul class="pure-g space-u-40"><li class="pure-u-3-4 pure-u-md-1 space-u-40-child">'+
					'<p class="mod-head03">'+catalogDate[k].name+'</p>'+
					'<ul class="ul-disc">';
					for(l = 0; l < catalogDate[k].item.length; l++) {
						if(catalogDate[k].item[l].class === 'small') {
							categorHtml += '<li class="disc-none"><a href="'+catalogDate[k].item[l].link+'" target="_blank" class="mod-link01 fs_14 fs_md12"><span>'+catalogDate[k].item[l].name.replace(/\r?\n/g, '<br>')+'</span><i class="imgicon imgicon-pdf"></i></a></li>';
						} else {
							categorHtml += '<li><a href="'+catalogDate[k].item[l].link+'" target="_blank" class="mod-link01"><span>'+catalogDate[k].item[l].name.replace(/\r?\n/g, '<br>')+'</span><i class="imgicon imgicon-pdf"></i></a></li>';
						}
					}
					if(!catalogDate[k].img) {
						categorHtml += '</ul></li></ul></div>';
					} else {
						categorHtml += '</ul></li><li class="pure-u-1-4 pure-u-md-1 space-u-40-child">'+
						'<figure class="ta_right ta_md_center"><img src="'+catalogDate[k].img+'" width="120" alt="'+catalogDate[k].name.replace(/\r?\n/g, '<br>')+'"></figure>'+
						'</li></ul></div>';
					}
					catalogBlock.append(categorHtml);
					if(lang === 'cn') {
						catalogHead.text('产品目录');
					} else if(lang === 'ja') {
						catalogHead.text('製品カタログ');
					} else {
						catalogHead.text('Product Catalog');
					}
				}
				// 出力データにクリックイベント
				$(document).on('click', '.inc_products_catalog a[rel="scroll"]', function(event){
					var speed = 1200;
					if(/#/.test(event.currentTarget.href)) {
						scrollToObject(event.currentTarget.href, speed);
					}
					return false;
				});
				function scrollToObject(_self, _speed){
					var hash = '#' + _self.split('#')[1];
					var pos = hash === '#pagetop' ? 0 : $(hash).offset().top;

					if(hash !== '#pagetop') {
						if(DIC.va.window.width < DIC.va.device.sp) {
							pos -= 60;
						} else {
							pos -= 100;
						}
					}
					$('html,body').stop().animate({ scrollTop: pos }, _speed, 'easeOutExpo');
				}
				// urlに#がある場合、ajax描画後にスクロールイベント発火
				const hash = location.hash;
				if(hash) {
					var _hash = '#' + hash.split('#')[1];
					if($(_hash).length) {
						$('body,html').css('opacity', 0);
						$('body,html').stop().scrollTop(0);
						setTimeout(function(){
							$('html, body').css('display', 'block');
							_hash = '#' + hash.split('#')[1];
							var pos = $(_hash).offset().top;

							if(DIC.va.window.width <= DIC.va.device.desktop) {
								pos -= 60;
							} else {
								pos -= 100;
							}
							$('body, html').css('opacity', 1);
							$('html, body').stop().animate({ scrollTop: pos }, 1200, 'easeOutExpo');
						}, 300);
					}
				}
			} else {
				catalogArea.addClass('di_none');
			}
		});
	};
	// 描画 ---------------------------------------------------
	// カタログ一覧のみ、属性ページでも表示
	if(!attributePage) {
		setJSONapp();
		setJSONlineup();
	}
	setJSONcatalog();

})(window.jQuery, window.DIC);
$(window).on('load', function(){
	// 中身のないエリア・ページ内アンカーをブロックごと非表示------
	const areaBlockHidden = () => {
		const aboutPageAnchor = $('.js-about-anchor');
		const aboutWrap = $('.js-about-area');
		const aboutWrapIn = $('.js-about-area-content');
		const aboutMore = $('.js-lineup-area-content .rt_cf_pc_about_detail_page_is_1');
		const aboutAjax = $('.js-lineup-area-content .inc_products_lineup');
		// const applicationPageAnchor = $('.js-application-anchor');
		// const applicationWrap = $('.js-application-area');
		// const applicationWrapIn = $('.js-application-area-content');
		const applicationMore = $('.js-application-area-content .rt_cf_pc_app_detail_page_is_1');
		const applicationAjax = $('.js-application-area-content .inc_products_application');
		const advantagePageAnchor = $('.js-advantage-anchor');
		const advantageWrap = $('.js-advantage-area');
		const advantageWrapIn = $('.js-advantage-area-content');
		// const lineupPageAnchor = $('.js-lineup-anchor');
		// const lineupWrap = $('.js-lineup-area');
		// const lineupWrapIn = $('.js-lineup-area-content');
		const lineupMore = $('.js-lineup-area-content .rt_cf_pc_lineup_detail_page_is_1');
		const lineupAjax = $('.js-lineup-area-content .inc_products_lineup');

		// ブロックの中身がなければ削除
		const areaHiddenJudgment = ($wrap, $wrapIn, $btn) => {
			if(!($wrapIn.text().replace(/^\s+/, '').length)) {
				$btn.addClass('is-hidden');
				$wrap.addClass('is-hidden');
			} else {
				$btn.addClass('is-active');
				$wrap.addClass('is-active');
			}
		};
		areaHiddenJudgment(aboutWrap, aboutWrapIn, aboutPageAnchor);
		areaHiddenJudgment(advantageWrap, advantageWrapIn, advantagePageAnchor);

		// moreボタンがあればajax出力部分削除
		const areaHiddenMore = ($more, $ajaxArea) => {
			if($more.length) {
				$ajaxArea.remove();
			}
		};
		areaHiddenMore(aboutMore, aboutAjax);
		areaHiddenMore(applicationMore, applicationAjax);
		areaHiddenMore(lineupMore, lineupAjax);

		// アンカーリンクがすべて非表示ならブロックごと削除
		if($('.mod-anchor .is-hidden').length === 4) {
			$('.mod-anchor').parent('.mod-spacer_70').remove();
		}
	};
	setTimeout(function(){
		areaBlockHidden();
	}, 500);
});
